import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store, Select } from '@ngxs/store';

import { Spinner, BcStateContext } from '@bayclubs/state';
import { BlockedSlotInfoModel, CourtBookingInfoModel, CourtClassInfoModel } from '@bayclubs/court-booking-employee-api';

import { CourtEventInfoSelectors } from './court-event-info.selectors';
import * as actions from './court-event-info.actions';

@Injectable({ providedIn: 'root' })
export class CourtEventInfoFacade {
    @Select(CourtEventInfoSelectors.blockedSlotDetails) blockedSlotDetails$: Observable<BcStateContext<BlockedSlotInfoModel>>;
    @Select(CourtEventInfoSelectors.spinner) spinner$: Observable<Spinner>;
    @Select(CourtEventInfoSelectors.courtBookingDetails) courtBookingDetails$: Observable<
        BcStateContext<CourtBookingInfoModel>
    >;
    @Select(CourtEventInfoSelectors.courtClassDetails) courtClassDetails$: Observable<BcStateContext<CourtClassInfoModel>    >;

    constructor(private store: Store) {}

    getBlockedSlotDetailsSnapshot = () => this.store.selectSnapshot(CourtEventInfoSelectors.blockedSlotDetails);

    loadBlockedSlotDetails = (blockedSlotId: string) =>
        this.store.dispatch(new actions.LoadBlockedSlotDetailsAction(blockedSlotId));
    clearLoadedBlockedSlot = () => this.store.dispatch(new actions.ClearLoadedBlockedSlotDetailsAction());
    goToBlockedSlotDetails = (blockedSlotId: string) =>
        this.store.dispatch(new actions.GotToBlockedSlotDetailsAction(blockedSlotId));

    loadCourtBookingDetails = (courtBookingId: string) =>
        this.store.dispatch(new actions.LoadCourtBookingDetailsAction(courtBookingId));
    clearLoadedCourtBooking = () => this.store.dispatch(new actions.ClearLoadedCourtBookingDetailsAction());
    goToCourtBookingDetails = (courtBookingId: string) =>
        this.store.dispatch(new actions.GoToCourtBookingDetailsAction(courtBookingId));
    checkInAllPlayers = (courtBookingId: string) =>
        this.store.dispatch(new actions.CheckInAllCourtBookingPlayersAction(courtBookingId));
    noShowAllPlayers = (courtBookingId: string) =>
        this.store.dispatch(new actions.NoShowAllCourtBookingPlayersAction(courtBookingId));
    checkInPlayer = (courtBookingId: string, playerId: string) =>
        this.store.dispatch(new actions.CheckInCourtBookingPlayerAction(courtBookingId, playerId));

    loadCourtClassDetails = (courtClassId: string) =>
        this.store.dispatch(new actions.LoadCourtClassDetailsAction(courtClassId));
    clearLoadedCourtClass = () => this.store.dispatch(new actions.ClearLoadedCourtClassDetailsAction());
    goToCourtClassDetails = (courtClassId: string) =>
        this.store.dispatch(new actions.GoToCourtClassDetailsAction(courtClassId));
}
